import { createReducer } from "@reduxjs/toolkit";
import * as actionTypes from "~/store/action_types";
import { deleteCalendarFromEventStream, loadCalendars, setCalendarFromEventStream } from "../actions/actions.calendars";

const reducer = createReducer({}, (builder) => {
  builder
    .addCase(setCalendarFromEventStream, (state, action) => {
      const { id } = action.payload;
      if (id) {
        state[id] = {
          ...state[id],
          ...action.payload,
        };
      }
      return state;
    })
    .addCase(deleteCalendarFromEventStream, (state, action) => {
      const { id } = action.payload;
      if (id) {
        const { [id]: _deleted, ...rest } = state;
        return rest;
      }
      return state;
    })
    .addCase(actionTypes.DELETE_CALENDAR_SUCCESS, (state, action) => {
      const { id = 0 } = action;
      if (id) {
        const { [id]: _deleted, ...rest } = state;
        return rest;
      }
      return state;
    })
    .addCase(loadCalendars, (state, action) => {
      if (action.payload) {
        state = {
          ...state,
          ...action.payload,
        };
      }
      return state;
    })
    .addCase(actionTypes.FETCH_CALENDAR_SUCCESS, (state, action) => {
      const { response = { entities: {}, result: {} } } = action;
      const { entities = { calendars: {} }, result = { count_events: 0 } } = response;
      const { calendars } = entities;
      const { count_events } = result;
      if (calendars) {
        let values = Object.values(calendars);
        if (values) {
          let calendar = values[0];
          return {
            ...state,
            [calendar.id]: { ...calendar, count_events: count_events },
          };
        }
      }
      return state;
    })
    .addMatcher(
      (action) =>
        [
          actionTypes.ADD_CALENDAR_SUCCESS,
          actionTypes.EDIT_CALENDAR_SUCCESS,
          actionTypes.FETCH_CALENDARS_SUCCESS,
          actionTypes.MOVE_CALENDAR_TO_TRASH_SUCCESS,
          actionTypes.RESTORED_CALENDAR_FROM_TRASH_SUCCESS,
          actionTypes.FETCH_ACTIVITY_LOGS_SUCCESS,
          actionTypes.ADD_EXTERNAL_CALENDAR_SUCCESS,
          actionTypes.REFRESH_EXTERNAL_CALENDAR_SUCCESS,
        ].includes(action.type),
      (state, action) => {
        const { response = { entities: {} } } = action;
        const { entities = { calendars: {} } } = response;
        const { calendars } = entities;
        if (calendars) {
          return {
            ...state,
            ...calendars,
          };
        }
        return state;
      }
    );
});

export default reducer;
